import { useEffect, useState, useCallback } from "react"
import { getClientReportPdfData } from "../../../services/clientReport.service"

const useClientReportPdfData = ({ periodId, clientId, periodType }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchData = useCallback(async () => {
    if (!periodId || !clientId || !periodType) {
      setData(null)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await getClientReportPdfData(
        periodId,
        clientId,
        periodType
      )

      if (!response?.success) {
        throw new Error(
          response?.message || "Error al obtener los datos del PDF"
        )
      }

      setData(response.result)
    } catch (err) {
      console.error("Error fetching client report PDF data:", err)
      setError(err)
      setData(null)
    } finally {
      setLoading(false)
    }
  }, [periodId, clientId, periodType])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    data,
    loading,
    error,
    refetch: fetchData,
  }
}

export default useClientReportPdfData
